export { OneDsLogger } from "./src/OneDsLogger";